import React from "react";
import { tCase } from "../../lib/textCase";

/**
 * Form field with auto Title Case on the label (Portuguese-aware).
 * Use everywhere a labelled input/select/textarea is needed.
 *
 *  <FormField label="Valor da limpeza (US$)" required>
 *    <input ... />
 *  </FormField>
 */
export function FormField({ label, required, hint, className = "", children }) {
  return (
    <label className={`block ${className}`}>
      <span className="block text-sm font-medium text-slate-700 mb-1">
        {typeof label === "string" ? tCase(label) : label}
        {required && <span className="text-red-500"> *</span>}
      </span>
      {children}
      {hint && (
        <span className="block text-[11px] text-slate-500 mt-1 leading-snug">
          {hint}
        </span>
      )}
    </label>
  );
}

export default FormField;
